import React, { useState } from "react";
import css from "../VenueListingDetails.module.scss";
import moment from "moment";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { postBookings } from "../../../redux/reducers/authSlice";
import { Link, useNavigate, useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import Spinner from "../../IconSpinner/IconSpinner";
import {
  ACTIVE,
  CUSTOMER,
  DUMMY_MONEY,
  FULFILLED,
  VENUE_MANAGER,
  timeArray,
} from "../../../constants/data";
import { ToastContainer, toast } from "react-toastify";
import { compose } from "redux";
import classNames from "classnames";
import IconCollection from "../../IconCollection/IconCollection";
import Select from "react-select";

const BookingForm = (props) => {
  const {
    priceForAdditionalStaff,
    priceForTechnicalInstruments,
    price_for_one_event,
    price_for_rehearsals,
    // except_dates,
    except_days,
    postBookingsApi,
    bookingStatus,
    usertype,
    currency,
    staff_rate,
    max_credits,
    credits_used,
    calendly_link,
    minimum_booking_fee,
    userListings,
    authorId,
    userId,
  } = props;

  const { subscription } = useSelector((state) => state.subscription) ?? {};

  const planStatus = subscription?.status;

  const isAuthor = userId === authorId;

  const { table, id } = useParams();
  const navigate = useNavigate();
  const [isReharsal, setIsReharsal] = useState(false);
  const [technicalInstrumentsPrice, setTechnicalInstrumentsPrice] = useState(
    priceForTechnicalInstruments || []
  );
  const [additionalStaffPrice, setAdditionalStaffPrice] = useState(
    priceForAdditionalStaff || []
  );
  const [reason, setReason] = useState("");
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null,
  });
  const [focusedInput, setFocusedInput] = useState(null);
  const [selectedShow, setSelectedShow] = useState(null);

  const handleChange = (selectedOption) => {
    setSelectedShow(selectedOption);
  };

  const isPaidSubscription = planStatus === ACTIVE || isAuthor;
  const creditLeft = max_credits - credits_used;
  const isBookable = creditLeft === 0;
  const startTime = moment(date?.startTime, "HH:mm");
  const endTime = moment(date?.endTime, "HH:mm");

  const sumForTechnicalInstruments = technicalInstrumentsPrice
    .filter((e) => e.qty > 0)
    .reduce((acc, e) => acc + e.qty * e.price.toFixed(2), 0);
  const sumForAdditionalStaff = additionalStaffPrice
    .filter((e) => e.qty > 0)
    .reduce((acc, e) => acc + e.qty * e.price.toFixed(2), 0);
  const rehearsalPrice = isReharsal ? +price_for_rehearsals : 0;
  const eventPrice =
    sumForTechnicalInstruments + sumForAdditionalStaff + +price_for_one_event;
  const totalPrice = (rehearsalPrice + eventPrice)?.toFixed(2);

  const isDayBlocked = (day) => {
    const formattedDate = moment(day).format("MM/DD/YYYY");
    return !isBookable ? except_days?.includes(formattedDate) : true;
  };

  const handleIncrease = (st) => {
    if (st.includes("price_for_technical_instruments_")) {
      const updatedItems = technicalInstrumentsPrice.map((item) => {
        if (item?.key === st) {
          return { ...item, qty: item?.qty + 1 };
        }
        return item;
      });
      setTechnicalInstrumentsPrice(updatedItems);
    } else {
      const updatedItems = additionalStaffPrice.map((item) => {
        if (item?.key === st) {
          return { ...item, qty: item?.qty + 1 };
        }
        return item;
      });
      setAdditionalStaffPrice(updatedItems);
    }
  };

  const handleDecrease = (st) => {
    if (st.includes("price_for_technical_instruments_")) {
      const updatedItems = technicalInstrumentsPrice.map((item) => {
        if (item?.key === st && item?.qty >= 1) {
          return { ...item, qty: item?.qty - 1 };
        }
        return item;
      });
      setTechnicalInstrumentsPrice(updatedItems);
    } else {
      const updatedItems = additionalStaffPrice.map((item) => {
        if (item?.key === st && item?.qty >= 1) {
          return { ...item, qty: item?.qty - 1 };
        }
        return item;
      });
      setAdditionalStaffPrice(updatedItems);
    }
  };
  const summaryTableArray = [
    ...technicalInstrumentsPrice,
    ...additionalStaffPrice,
  ]?.filter((item) => item.qty > 0);
  const onSubmit = async () => {
    const data = {
      start_date: moment(date?.startDate).format("L"),
      end_date: moment(date?.endDate).format("L"),
      start_time: moment(startTime).format("LT"),
      end_time: moment(endTime).format("LT"),
      staff_rate,
      message: reason,
      booking_listing_id: selectedShow?.value,
    };
    if (isPaidSubscription) {
      Object.assign(data, {
        price: {
          amount: Number(totalPrice),
          currency: "eur",
          price_for_rehearsals,
          price_for_one_event,
          is_reharsal: isReharsal,
          items: summaryTableArray,
        },
      });
    } else {
      Object.assign(data, {
        price: {
          amount: Number(minimum_booking_fee),
          currency: "eur",
        },
      });
    }
    try {
      const res = await postBookingsApi({ table, id, data });
      if (res?.payload?.status === 200) {
        toast.success(res?.payload?.data?.message);
        navigate(
          `/inbox/${CUSTOMER}/requests/${
            res?.payload?.data?.data?.booking[
              res?.payload?.data?.data?.booking?.length - 1
            ]
          }`
        );
      } else {
        toast.warn(res?.payload?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const customOption = (props) => {
    const { innerRef, innerProps, data } = props;
    return (
      <div ref={innerRef} {...innerProps} className={css.selectMenu}>
        <img src={data.image} alt={data.artist_name} loading="lazy" />
        <div>
          <div>{data.artist_name}</div>
          <div className={css.genreText}>{data.genre}</div>
        </div>
      </div>
    );
  };
  const options = userListings.map((listing) => ({
    value: listing?.id,
    artist_name: listing?.artist_name,
    genre: listing?.genre,
    image: listing?.poster?.url,
    label: `${listing?.artist_name}, ${listing?.genre}`,
  }));
  const submitDisable =
    usertype === VENUE_MANAGER ||
    !reason ||
    !date?.startDate ||
    !date?.endDate ||
    !date?.startTime ||
    !date?.endTime ||
    isBookable ||
    !selectedShow?.value;
  return (
    <div>
      <div className={css.orderWrapper}>
        {!isAuthor && (
          <>
            {userListings?.length > 0 && usertype !== VENUE_MANAGER ? (
              <div className={css.chooseListing}>
                <h6 className={css.calenderText}>Choose Your Listing</h6>
                <Select
                  className={css.multiSelectBox}
                  options={options}
                  components={{ Option: customOption }}
                  onChange={handleChange}
                  placeholder="Select a show"
                />
              </div>
            ) : (
              <h2 style={{ color: "red" }}>No shows found cannot book</h2>
            )}
          </>
        )}

        <div className={css.orderContents}>
          <h6 className={css.calenderText}>Calender</h6>
          <DateRangePicker
            startDate={date?.startDate}
            startDateId="start_date"
            endDate={date?.endDate}
            endDateId="end_date"
            onDatesChange={(dates) => {
              setDate(dates);
            }}
            focusedInput={focusedInput}
            onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
            isDayBlocked={isDayBlocked}
            numberOfMonths={1}
            hideKeyboardShortcutsPanel={true}
            minimumNights={0}
          />
          {date.startDate && date.endDate && (
            <div className={css.timeInputs}>
              <div>
                <select
                  name="startTime"
                  id="startTime"
                  onChange={(e) =>
                    setDate({ ...date, startTime: e.target.value })
                  }
                >
                  <option value="">Start Time</option>
                  {timeArray?.map((time) => (
                    <option key={time.key} value={time.key}>
                      {time.label}
                    </option>
                  ))}
                </select>
              </div>
              <IconCollection name="RIGHT_ARROW" />
              <div>
                <select
                  name="endTime"
                  id="endTime"
                  onChange={(e) =>
                    setDate({ ...date, endTime: e.target.value })
                  }
                >
                  <option value="">End Time</option>
                  {timeArray
                    ?.filter(
                      (startTime) =>
                        date?.startTime && date?.startTime < startTime.key
                    )
                    ?.map((time) => (
                      <option key={time.key} value={time.key}>
                        {time.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          )}
        </div>
        <div>
          {/* <select name="bookingListingId" id="bookingListingId" onChange={(e) => setDate({ ...date, startTime: e.target.value })}>
            <option value="">Select Listing ID</option>
            {allListing.map(listing => <option key={listing.id} value={listing.key}>{listing.label}</option>)}
          </select> */}
        </div>
        <div className={css.orderContents}>
          <h6>Price for Technical equipment</h6>
          <div>
            {technicalInstrumentsPrice?.map((st) => {
              const name = st?.key.substring(
                "price_for_technical_instruments_".length
              );
              return (
                <div key={st?.key} className={css.orderContent}>
                  <div className={css.orderText}>{name}</div>
                  <div className={css.rightTexts}>
                    <div
                      className={classNames(
                        isPaidSubscription || isAuthor ? null : css.blur,
                        css.priceCount
                      )}
                    >
                      {currency}
                      {isPaidSubscription || isAuthor
                        ? st?.price.toFixed(2)
                        : DUMMY_MONEY}
                      /per
                    </div>
                    <div className={css.countNumber}>
                      <span
                        id={`${name}Quantity`}
                        name={`${name}Quantity`}
                        onClick={() => handleIncrease(st?.key)}
                      >
                        {" "}
                        +{" "}
                      </span>
                      <span className={css.countQuantity}>{st?.qty}</span>
                      <span
                        id={`${name}Quantity`}
                        name={`${name}Quantity`}
                        onClick={() => handleDecrease(st?.key)}
                      >
                        {" "}
                        -{" "}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
            {technicalInstrumentsPrice?.length === 0 &&
              ["Microphone", "Screen", "Projector", "Laptop"].map(
                (item, index) => {
                  return (
                    <div key={index} className={css.orderContent}>
                      <div className={css.orderText}>{item}</div>
                      <div className={css.rightTexts}>
                        <div
                          className={classNames(
                            isPaidSubscription || isAuthor ? null : css.blur,
                            css.priceCount
                          )}
                        >
                          {currency}
                          {isPaidSubscription || isAuthor
                            ? item?.price
                            : DUMMY_MONEY}
                          /person
                        </div>
                        <div className={css.countNumber}>
                          <span id={`${item}Quantity`} name={`${item}Quantity`}>
                            {" "}
                            +{" "}
                          </span>
                          <span className={css.countQuantity}>{0}</span>
                          <span id={`${item}Quantity`} name={`${item}Quantity`}>
                            {" "}
                            -{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
          </div>
        </div>
        <div className={css.orderContents}>
          <h6 className={css.capitalize}>{`Price for additional Staff ${
            staff_rate ? `(${staff_rate})` : ""
          }`}</h6>
          <div>
            {additionalStaffPrice?.map((st) => {
              const name = st?.key.substring(
                "price_for_additional_staff_".length
              );
              return (
                <div key={st?.key} className={css.orderContent}>
                  <div className={css.orderText}>{name.replace("_", " ")}</div>
                  <div className={css.rightTexts}>
                    <div
                      className={classNames(
                        isPaidSubscription || isAuthor ? null : css.blur,
                        css.priceCount
                      )}
                    >
                      {currency}
                      {isPaidSubscription || isAuthor
                        ? st?.price?.toFixed(2)
                        : DUMMY_MONEY}
                      /person
                    </div>
                    <div className={css.countNumber}>
                      <span
                        id={`${name}Quantity`}
                        name={`${name}Quantity`}
                        onClick={() => handleIncrease(st?.key)}
                      >
                        {" "}
                        +{" "}
                      </span>
                      <span className={css.countQuantity}>{st?.qty}</span>
                      <span
                        id={`${name}Quantity`}
                        name={`${name}Quantity`}
                        onClick={() => handleDecrease(st?.key)}
                      >
                        {" "}
                        -{" "}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
            {additionalStaffPrice?.length === 0 &&
              [
                "Hostess",
                "Ticket Salesman",
                "Audio Technician",
                "Lighting Technician",
                "Rigger",
              ].map((item, index) => {
                return (
                  <div key={index} className={css.orderContent}>
                    <div className={css.orderText}>{item}</div>
                    <div className={css.rightTexts}>
                      <div
                        className={classNames(
                          isPaidSubscription || isAuthor ? null : css.blur,
                          css.priceCount
                        )}
                      >
                        {currency}
                        {isPaidSubscription || isAuthor
                          ? item?.price
                          : DUMMY_MONEY}
                        /person
                      </div>
                      <div className={css.countNumber}>
                        <span id={`${item}Quantity`} name={`${item}Quantity`}>
                          {" "}
                          +{" "}
                        </span>
                        <span className={css.countQuantity}>{0}</span>
                        <span id={`${item}Quantity`} name={`${item}Quantity`}>
                          {" "}
                          -{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <div className={css.priceContent}>
          <div>
            <h6>Price to rent for rehearsals only</h6>
            <div className={css.rehearsalCheck}>
              <input
                id="rehearsal"
                name="rehearsal"
                type="checkbox"
                onClick={() => setIsReharsal((prev) => !prev)}
              />
              <label htmlFor="rehearsal">Opt for Rehearsal</label>
            </div>
          </div>
          <div>
            <p className={css.priceText}>
              <span
                className={classNames(
                  css.orderText,
                  isPaidSubscription || isAuthor ? null : css.blur
                )}
              >
                {isPaidSubscription || isAuthor
                  ? `${currency}${price_for_rehearsals}`
                  : DUMMY_MONEY}
              </span>
            </p>
            <span className={css.vatText}>excl. VAT</span>
          </div>
        </div>
        <div className={css.priceContent}>
          <h6>Price for one event</h6>
          <div>
            <p className={css.priceText}>
              <span
                className={classNames(
                  css.orderText,
                  isPaidSubscription || isAuthor ? null : css.blur
                )}
              >
                {isPaidSubscription || isAuthor
                  ? `${currency}${price_for_one_event}`
                  : DUMMY_MONEY}
              </span>
            </p>
            <span className={css.vatText}>excl. VAT</span>
          </div>
        </div>
        {isPaidSubscription && (
          <div className={css.summaryContent}>
            <h6>Summary</h6>
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {isReharsal && (
                  <tr>
                    <td>Price for Rehearsal</td>
                    <td>1</td>
                    <td>€{(+price_for_rehearsals).toFixed(2)}</td>
                  </tr>
                )}
                <tr>
                  <td>Price for Event</td>
                  <td>1</td>
                  <td>€{(+price_for_one_event).toFixed(2)}</td>
                </tr>
                {isPaidSubscription &&
                  summaryTableArray.map((item) => {
                    const isAdditionalStaff = item?.key.includes(
                      "price_for_additional_staff_"
                    );
                    const name = isAdditionalStaff
                      ? item?.key.substring(
                          "price_for_additional_staff_".length
                        )
                      : item?.key.substring(
                          "price_for_technical_instruments_".length
                        );
                    return (
                      <tr key={item.key}>
                        <td className={css.capitalize}>
                          {isAdditionalStaff ? name.replace("_", " ") : name}
                        </td>
                        <td>{item.qty}</td>
                        <td>€{(item.qty * item.price).toFixed(2)}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
        <div className={css.priceContent}>
          <h6>Total costs</h6>
          <div>
            <p className={css.priceText}>
              <span
                className={classNames(
                  css.orderText,
                  isPaidSubscription || isAuthor ? null : css.blur
                )}
              >
                {isPaidSubscription || isAuthor
                  ? `${currency}${totalPrice}`
                  : DUMMY_MONEY}
              </span>
            </p>
            <span className={css.vatText}>excl. VAT</span>
          </div>
        </div>
        <div>
          <label className={css.reasonLabel} htmlFor="reason">
            Message*:
          </label>
          <div>
            <textarea
              placeholder="Message"
              rows={3}
              id="reason"
              name="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>
        <button
          type="button"
          className={css.bookButton}
          disabled={submitDisable}
          onClick={onSubmit}
        >
          {bookingStatus === FULFILLED ? (
            <Spinner rootClassName={css.spinner} />
          ) : (
            "Book"
          )}
        </button>
        <button
          disabled={
            !isPaidSubscription ||
            isAuthor ||
            usertype === VENUE_MANAGER ||
            !calendly_link
          }
          className={css.calendlyButton}
        >
          <Link to={calendly_link ?? null} target="_blank">
            Calendly
          </Link>
        </button>
        {isAuthor ? (
          <p className={css.registeredText}>Own listing cannot book.</p>
        ) : null}
        {!isPaidSubscription && !isAuthor && (
          <p className={css.registeredText}>
            User must be registered and subscribed to access these features
          </p>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};
const mapStateToProps = (state) => {
  const {
    bookingStatus,
    usertype,
    max_credits,
    credits_used,
    id: userId,
  } = state.user.user ?? {};
  // const { allListing, status } = state.listing ?? {};
  const calendly_link = state.listing?.currentListing?.calendly_link;

  return {
    bookingStatus,
    usertype,
    max_credits,
    credits_used,
    calendly_link,
    userId,
  };
};
const mapDispatchToProps = (dispatch) => ({
  postBookingsApi: (data) => dispatch(postBookings(data)),
});
export default compose(connect(mapStateToProps, mapDispatchToProps))(
  BookingForm
);
